export const data = () => {
  const canvas = document.getElementById("canvas");
  let width = 1000;
  let height = 562.5;
  if (window.innerWidth < 1000 || window.innerHeight < 562.5) {
    if (window.innerHeight < window.innerWidth) {
      height = window.innerHeight - 20;
      width = height * 1.7778; // 16/9
    } else {
      width = window.innerWidth - 20;
      height = width * 0.5625; // 9/16
    }
  }
  const scale = window.devicePixelRatio;
  canvas.width = width * scale;
  canvas.height = height * scale;
  let scaleX = (width / 1000) * scale;
  let ScaleY = (height / 562.5) * scale;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  return { width, height, scaleX, ScaleY };
};
export var finance = {
  coins: 50,
  freePlay: 3,
  skinned: false,
  level: 1,
  startSound: true,
};
export var dbObject = {
  timeStarted: null,
  timeEnded: null,
  timePlayedInSec: 0,
  progress: "",
  platform: "web",
  ipAddress: "",
  didOpenChest: false,
  chestPrize: ["Did Not Open Chest"],
  geoData: {},
};
export var readyToOpen = { value: false };
export var areAssetsLoaded = { value: false };
